<template>
    <div id="page-header">
        <div class="container-fluid">
            <div class="page-header-wrapper">
                <div class="page-header-content" :style="{textAlign: 'left'}">
                    <h1 v-if="isSingle">{{ title }}</h1>
                    <h1 v-else>{{ title }}</h1>
                    <br/>
                    <h5>
                        <div v-if="!isSingle" v-html="content" />
                    </h5>
                </div>
                <div v-if="thumbnailUrl" class="page-header-image" :class="imageSize">
                    <img :src="photo" :alt="title" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        photo: String,
        title: String,
        content: String,
        imageSize: {
            type: String,
            default: 'normal' // Options: 'small', 'normal', 'large'
        }
    },
    data() {
        return {
            isSingle: false,
            thumbnailUrl: require('@/assets/404.jpg'),
        };
    },
    
    methods: {
    },
};
</script>

<style scoped>
@import '@/css/main.css';

.page-header-image {
    transition: all 0.3s ease;
}

.page-header-image.small img {
    max-width: auto;
    max-height: 200px;
    width: auto;
    height: auto;
}

.page-header-image.normal img {
    max-width: auto;
    max-height: 400px;
    width: auto;
    height: auto;
}

.page-header-image.large img {
    max-width: auto;
    max-height: 600px;
    width: auto;
    height: auto;
}
</style>
